import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

  public isCustomized: boolean;

  constructor(private router: Router) {
    if (location.pathname.replace(/\//g, '')) {
      this.isCustomized = true;
    }
  }

  public navigateTo(elementId: string) {
    if (location.hash === '#/makepwd' || location.hash === '#/login') {
      return this.router.navigateByUrl('/');
    }
    return document.getElementById(elementId).scrollIntoView();
  }

}



// WEBPACK FOOTER //
// ./src/app/public/footer/footer.component.ts